<!-- @format -->

<ng-container *transloco="let t">
  <sis-checkbox
    [label]="t('TIMELINE.SHOW_PAST_STUDY_TERMS')"
    [checked]="isChecked$ | async"
    (checkedChange)="setShowPastStudyTerms($event)"></sis-checkbox>
</ng-container>
